import React, { FC } from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface ObjectLinkCellProps {
  objectName: string;
  objectUniqueId: string;
}

const ObjectLinkCell: FC<ObjectLinkCellProps> = ({
  objectName,
  objectUniqueId
}) => {
  const navigate = useNavigate();

  const handleObjectClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/dashboard/objects/details/${objectUniqueId}`);
  };

  return (
    <Typography
      component="a"
      onClick={handleObjectClick}
      sx={{
        color: "#00B2A3",
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer",
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline",
          color: "#009688"
        }
      }}
    >
      {objectName || "None"}
    </Typography>
  );
};

export default ObjectLinkCell;
